class LookBook extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('.lookbook__popup');
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {      
      switch (true) {
        case e.target.classList.contains('lookbook__trigger'):
          this.handleTriggerClick(e);
          break;
        case e.target.classList.contains('lookbook__add-to-cart'):
          this.handleAddToCart(e);
          break;
        case e.target.classList.contains('lookbook__close'):
          this.hideModal();
          break;
        case e.target.classList.contains('lookbook__nav'):
          this.popup.classList.remove('lookbook__popup--visible')
          const timeout = setTimeout(() => {
            this.changeLook(e);
            clearTimeout(timeout);
          }, 300);
          break;
      }
    });

    new ResizeObserver(() => {
      const loadedImage = this.popup.querySelector('.lookbook__popup-image img');
      if (loadedImage) this.popup.style.setProperty('--lookbook-image-width', `${loadedImage.clientWidth}px`);
    }).observe(this.popup);

    this.addEventListener('change', (e) => this.handleVariantChange(e));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup && this.popup.classList.contains('is-active')) {
        this.hideModal();
      } else if (e.key === 'ArrowLeft' && this.popup && this.popup.classList.contains('is-active')) {
        this.popup.querySelector('.lookbook__prev')?.click();
      } else if (e.key === 'ArrowRight' && this.popup && this.popup.classList.contains('is-active')) {
        this.popup.querySelector('.lookbook__next')?.click();
      }
    });
  }

  changeLook(e) {
    if (!this.popup) return;
    const looks = this.querySelectorAll(".lookbook__trigger");
    const lastLookIndex = looks[looks.length - 1].dataset.index;
    const currentIndex = parseInt(this.popup.getAttribute('data-index'));
    let newIndex = currentIndex;
    
    if (e.target.classList.contains('lookbook__prev')) {
      newIndex = currentIndex == 1 ? lastLookIndex : currentIndex - 1;
    } else {
      newIndex = currentIndex == lastLookIndex ? 1 : currentIndex + 1;
    }

    const nextLook = this.querySelector(`.lookbook__trigger[data-index="${newIndex}"]`);
    if (nextLook) nextLook.click();
  }

  async addToCart(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'items': [{
          id: Number(variantId),
          quantity: 1,
        }]
      }),
    })
    .then(response => {
      return response.json()
    })
    .then((data) => {
      if (data.items) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));  
        const drawer = document.querySelector('#cart-drawer');
        if(drawer) drawer.show();
      } else {
        if (data.status && data.status != '200') alert(data.description);
      }
    });
  }

  handleAddToCart(e) {
    const nearestPartProduct = e.target.closest('.lookbook__part');
    const connectedSelect = nearestPartProduct?.querySelector('.lookbook__part-select');
    if (!connectedSelect) return;
    this.addToCart(connectedSelect.value);
  }

  handleVariantChange(e) {
    const selectedVariantPrice = e.target.options[e.target.selectedIndex].dataset.price;
    const availability = e.target.options[e.target.selectedIndex].dataset.availability;
    const nearestPartProduct = e.target.closest('.lookbook__part');
    const partProductPrice = nearestPartProduct.querySelector('.lookbook__part-price');
    const partProductAddToCart = nearestPartProduct.querySelector('.lookbook__add-to-cart');

    if (partProductPrice) partProductPrice.innerHTML = selectedVariantPrice;

    if (availability == "true") {
      partProductAddToCart.removeAttribute('disabled');
      partProductAddToCart.textContent = partProductAddToCart.dataset.availableText;
    } else {
      partProductAddToCart.setAttribute('disabled', "");
      partProductAddToCart.textContent = partProductAddToCart.dataset.unavailableText;
    }
  }

  handleTriggerClick(e) {
    if (!this.popup) return;
    const photo = e.target.querySelector(".lookbook__image");
    
    const popupImage = this.popup.querySelector('.lookbook__popup-image');
    if (popupImage) popupImage.innerHTML = '';

    let content = null
    const contentTemplate = e.target.parentElement.querySelector(".lookbook__parts");
    if (contentTemplate) content = contentTemplate.content.cloneNode(true);
    
    const popupContent = this.popup.querySelector('.lookbook__popup-parts');
    if (popupContent) popupContent.innerHTML = '';

    if (popupImage && photo) {
      const cloneOfImg = photo.cloneNode(true);      
      popupImage.appendChild(cloneOfImg);
    }
    if (popupContent && content) popupContent.appendChild(content);

    this.popup.setAttribute('data-index', e.target.dataset.index);
    this.showModal()
  }

  showModal() {
    if (!this.popup) return;
    this.popup.classList.add('is-active');
    document.body.classList.add('popup-open')
    const timeout = setTimeout(() => {
      this.popup.classList.add('lookbook__popup--visible')
      clearTimeout(timeout);
    }, 50);
  }

  hideModal() {
    if (!this.popup) return;
    this.popup.classList.remove('lookbook__popup--visible')
    this.popup.classList.remove('is-active');
    document.body.classList.remove('popup-open')
  }
}

if (!customElements.get('look-book')) customElements.define('look-book', LookBook);